import React, { Fragment } from 'react';
import { Container } from 'reactstrap';
import { Switch, Route } from 'react-router-dom';
import {
  ADMIN_PATH,
  ADMIN_DASHBOARD_PATH,
  ADMIN_USERS_PATH,
  ADMIN_AGENCIES_PATH,
  ADMIN_REQUESTS_PATH,
  ADMIN_PAYMENTS_PATH,
  PAGE_NOT_FOUND_PATH,
  ADMIN_PROFILE_PATH,
  ADMIN_AGENCYDETAILS_PATH,
  ADMIN_SERVICE_REQUESTS_PATH,
} from '../../../utils/AppRoutes';

import AdminSidebar from './AdminSidebar.jsx';
import AdminHeader from './AdminHeader.jsx';
import Admins from '../admins/index.jsx';
import AdminAgencies from '../agencies/index.jsx';
import AdminRequests from '../requests/index.jsx';
import AdminPayments from '../payments/index.jsx';
import Profile from '../profile/index.jsx';
import AdminDashboard from '../dashboard/index.jsx';
import View from '../agencies/view.jsx';
import CustomPageNotFound from '../../common/CustomPageNotFound';
import AdminServiceRequests from '../serviceRequests';

const AdminLayout = (props) => {
  return (
    <Fragment>
      {/* Header */}
      <AdminHeader />
      {/* Header */}

      {/* Sidebar */}
      <AdminSidebar />
      {/* Sidebar */}

      <div className="admin-body">
        <Container>
          <Switch>
            <Route exact path={ADMIN_PATH} component={AdminDashboard} />
            <Route
              exact
              path={ADMIN_DASHBOARD_PATH}
              component={AdminDashboard}
            />
            <Route exact path={ADMIN_USERS_PATH} component={Admins} />
            <Route exact path={ADMIN_AGENCIES_PATH} component={AdminAgencies} />
            <Route
              exact
              path={ADMIN_AGENCYDETAILS_PATH + '/:id'}
              component={View}
            />
            <Route exact path={ADMIN_REQUESTS_PATH} component={AdminRequests} />
            <Route
              exact
              path={ADMIN_SERVICE_REQUESTS_PATH}
              component={AdminServiceRequests}
            />
            <Route exact path={ADMIN_PAYMENTS_PATH} component={AdminPayments} />
            <Route exact path={ADMIN_PROFILE_PATH} component={Profile} />

            <Route path={PAGE_NOT_FOUND_PATH} component={CustomPageNotFound} />
          </Switch>
        </Container>
      </div>
    </Fragment>
  );
};
export default AdminLayout;
